import clsx from 'clsx';
import { type PropsWithChildren } from 'react';

import { svgElement } from './MeterBarPlot.sty.js';
import { METER_BAR_CHART_PLOT_ARIA_LABEL } from '../../../single-meter-bar/constants.js';
import { METER_BAR_SIZE } from '../../constants.js';
import { useMeterBarLayoutSize } from '../../context/MeterBarLayoutSize.context.js';
import { elementSize } from '../../styles/element-size.sty.js';

export const MeterBarPlot = ({ children }: PropsWithChildren) => {
  const { size, segmentHeight } = useMeterBarLayoutSize();

  const isSegmentHeight = size === METER_BAR_SIZE.Auto;

  return (
    <svg
      height={isSegmentHeight ? segmentHeight : undefined}
      className={clsx(svgElement, elementSize({ size }))}
      aria-label={METER_BAR_CHART_PLOT_ARIA_LABEL}
    >
      {children}
    </svg>
  );
};
